import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import moment from "moment";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageSalary = () => {

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);

  const [roles, setRoles] = useState([
    {
      _id: 1,
      name: "sales"
    },
    {
      _id: 2,
      name: "survey"
    },
    {
      _id: 3,
      name: "telecalling"
    },
    {
      _id: 4,
      name: "data entry"
    },
    {
      _id: 5,
      name: "branch manager"
    },
    {
      _id: 6,
      name: "freelancer"
    }
  ]);

  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => ({
    id: index,
    name: currentYear - 2 + index
  }));

  const initialFormData = {
    city: "",
    type: "", //staff,freelancer
    commission: 0,
    remarks: "",
    staffId: "", //freelancer or staff id
    date: "", //2025-01-19
    month: "",
    year: "",
    addedBy: loggedUserID,
  }

  const [editData, setEditData] = useState(initialFormData);
  const [editID, setEditID] = useState("");
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const fetchAllData = async () => {
    try {
      const res = await HomeService.getSalary();

      console.log("UYT40", res.data)
      if (res?.status) {
        if (userCity) {
          setAllData(res.data.filter((item) => item?.city._id === userCity).sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || []);
        } else {
          setAllData(res.data.sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || []);
        }
      } else {
        toast.error("Failed to fetch allData.");
      }
    } catch (error) {
      toast.error("Error fetching allData.");
      console.error("Error fetching allData:", error);
    } finally {
      setLoading(false);
    }
  };

  const [cities, setCities] = useState([]);
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.status) {
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          fetchLocalities(userCity)
        } else {
          setCities(res.data);
        }
      } else {
        toast.error("Failed to fetch cities.");
      }
    } catch (error) {
      toast.error("Error fetching cities.");
      console.error("Error fetching cities:", error);
    }
  };

  const [staffs, setStaffs] = useState([]);
  // Fetch Staffs
  const fetchStaffs = async (city, role) => {
    console.log("OIU101", city, role);

    // const type = role === "staff" ? "sales" : role
    try {
      const res = await HomeService.getStaffs();
      console.log("KIU77", res.data);

      if (res?.data) {
        setStaffs(res.data.filter(
          (item) => item.role === role && item?.city._id === city
        ));
      }
    } catch (error) {
      console.error("Error fetching staffs:", error);
    }
  }

  const [localities, setLocalities] = useState([]);

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      // console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  }

  // useEffect(() => {
  //   console.log("YTR90",editData.city[0]);
  //   fetchLocalities(editData.city[0])
  // }, [editData?.city])



  const handleEdit = (row) => {
    console.log("OIUY102", row);

    setIsEdit(true);
    setAllSelected(false)

    // const editSection = document.getElementById("edit-section");
    // if (editSection) {
    //   editSection.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //   });
    // }

    setEditID(row._id);
    fetchStaffs(row?.city?._id, row?.staffType)

    setEditData({
      ...row,
      city: row?.city?._id,
      staffId: row?.staff?._id,
      date: row?.date?.split("T")[0],
    });
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === true ? false : true;
      await HomeService.updateSalaryStatus(id, { status: newStatus });
      fetchAllData();
      toast.success(`Status updated successfully`);
    } catch (error) {
      // toast.error("Failed to update Commission status.");
      console.error("Error updating status:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      // const updatedData = {
      //   userId: editData.userId,
      //   cityId: editData.city,
      //   locality: editData.locality,
      //   price: parseInt(editData.price),
      //   startDate: editData.startDate,
      //   endDate: editData.endDate,
      //   date: editData.date,
      //   remarks: editData.remarks,
      // }

      console.log("IUY151", editData);
      // return

      const res = await HomeService.updateSalary(
        editID,
        editData
      );

      if (res) {
        toast.success("Salary updated successfully!");
        setIsEdit(false);
        fetchAllData();
      }
    } catch (error) {
      toast.error("Failed to update Salary.");
      console.error("Error saving Salary:", error);
    }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setEditData((prevData) => ({
      ...prevData,
      cityNames: prevData.cityNames.includes(value)
        ? prevData.cityNames.filter((city) => city !== value)
        : [...prevData.cityNames, value],
    }));
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: `Delete Subscription?`,
      text: "Are you sure you want to delete this Subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteSubscription(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Subscription has been deleted.", "success");
          fetchAllData()
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Subscription.", "error");
      }
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "City",
      selector: (row) => row?.city?.name,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row?.staffType,
      sortable: true,
    },
    {
      name: "Staff",
      selector: (row) => row?.staff?.name || "N/A",
      sortable: true,
    },
    {
      name: "Salary",
      selector: (row) => row?.salary,
      sortable: true,
    },
    {
      name: "Month",
      selector: (row) => row?.month,
      wrap: true,
    },
    {
      name: "Year",
      selector: (row) => row?.year,
      wrap: true,
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}

            ></i>
          </span>

          {/* <span title="Delete" onClick={() => handleDelete(row._id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const formatDateForDisplay = (date) => {
    if (!date) return ""; // Handle empty or invalid dates
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };
  const [userList, setUserList] = useState([]);
  const fetchUserList = async () => {
    try {
      const usersResponse = await HomeService.getUsers();

      if (userCity) {
        setUserList(usersResponse.data.filter(item => item?.city._id === userCity))
      } else {
        setUserList(usersResponse?.data || []);
      }
      // setCityList(citiesResponse?.data || []);
    } catch (error) {
      toast.error("Failed to fetch user or city list.");
      console.error("Error fetching data:", error);
    }
  }

  const handleLocalityChange = (e) => {
    const value = e.target.value;
    console.log("UYT172", value);

    setEditData((prevData) => ({
      ...prevData,
      locality: prevData.locality.includes(value)
        ? prevData.locality.filter((item) => item !== value)
        : [...prevData.locality, value],
    }));
    setAllSelected(false)
  };

  const [allSelected, setAllSelected] = useState(false)
  const handleSelectAllLocations = (e) => {
    // console.log("JUY189", localities, locationIds, e.target.value);
    let allLocalities = localities.map(item => item._id);
    if (allSelected) {
      allLocalities = []
    }
    setEditData((prevData) => ({
      ...prevData,
      locality: allLocalities
    }));
    // setLocationIds(allLocalities)
    setAllSelected(!allSelected)
  };



  useEffect(() => {
    fetchAllData();
    fetchUserList()
    fetchCities();

  }, []);

  useEffect(() => {
    console.log("ERR407", editData.city, editData.type);

    fetchStaffs(editData.city, editData.staffType)
  }, [editData.city, editData.staffType])

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid edit-section">
        {isEdit ? (
          <section className="chartBox_area">
            <h2>Edit Salary</h2>
            <hr />
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={editData.city}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        city: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Type<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="staffType"
                    value={editData?.staffType || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        staffType: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {roles.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Staff<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="staffId"
                    value={editData?.staffId || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        staffId: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {staffs.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name} ({item?.designation?.name})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Salary<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="commission"
                    value={editData?.salary || 0}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        salary: e.target.value,
                      })
                    }
                    placeholder="Enter salary"
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={editData?.date}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        date: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Month<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="month"
                    value={editData?.month || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        month: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {months.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Year<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="year"
                    value={editData?.year || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        year: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>---Select---</option>
                    {years.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="endDate">
                    Remarks
                  </label>
                  <textarea
                    name="remarks"
                    className="form-control"
                    value={editData?.remarks || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        remarks: e.target.value,
                      })
                    }
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>




              </div>
              <button style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} type="submit" className="btn mt-3">
                Submit
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3"
                style={{ marginLeft: "11px" }}
                onClick={() => setIsEdit(false)}
              >
                Cancel
              </button>
            </form>
          </section>
        ) : (
          <>
            <div className="mt-5">
              <div style={headLineStyle} className="page-headline">
                Manage Salary
              </div>
              <hr />
              <button type="submit" style={{
                background: '#fff',
                border: "solid 2px #85da4f",
                borderRadius: '13px',
                margin: '10px'
              }} className="btn mt-3"
                onClick={() => { navigate("/add-salary") }}
              >
                Add Salary
              </button>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <section className="chartBox_area">
                  <DataTable
                    columns={columns}
                    data={allData}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </section>
              )}
            </div>
          </>
        )}


      </div>
    </div>
  );
};

export default ManageSalary;
